import React, { useState, useEffect, useRef } from "react";
import { trackEvent } from "./../../utils/analytics";
import { useLocation, Navigate } from "react-router-dom";
import { getStatementApi } from "../../apis/apis";

const Statement: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const iframe = useRef<any>(null);
  const locationState = useLocation().state as { link?: string } | null;
  const link = locationState?.link;

  useEffect(() => {
    if (!link) return;
    trackEvent({
      action: "View Statement",
      value: link,
    });
    (async () => {
      try {
        const objectUrl = await getStatementApi(link);
        if (iframe.current) iframe.current.src = objectUrl;
      } finally {
        setLoading(false);
      }
    })();
  }, [link]);

  if (!link) {
    return <Navigate to="/statements" replace />;
  }

  return (
    <>
      {loading && <div style={{ padding: 30 }}>Loading...</div>}
      <iframe
        ref={iframe}
        title="Statement"
        style={{ width: "100%", height: "100vh" }}
        frameBorder="0"
      ></iframe>
    </>
  );
};

export default Statement;
